import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h2 class=\"anchor fw-bolder mb-5\"><a href=\"#control-the-size-of-the-space\"></a> Control the size of the space </h2><div class=\"py-5\"> Control the space size via <code>size</code> API. You can set the size with built-in sizes <code>mini</code>, <code>small</code>, <code>medium</code>, <code>large</code>, these size coresponds to <code>4px</code>, <code>8px</code>, <code>12px</code>, <code>16px</code>. The default size is <code>small</code>, A.K.A. <code>8px</code> You can also using customized size to override it. Refer to the next part. </div>", 2)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("mini")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("small")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("medium")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("large")
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Card name", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Operation button")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_space, {
        direction: "vertical",
        alignment: "start",
        size: 30
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.size,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.size = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { label: 'mini' }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 'small' }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 'medium' }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 'large' }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_space, {
            wrap: "",
            size: _ctx.size
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                return _createVNode(_component_el_card, {
                  class: "box-card",
                  style: {"width":"250px"},
                  key: i
                }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_button, {
                        class: "button",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (o) => {
                      return _createVNode("div", {
                        key: o,
                        class: "text item"
                      }, _toDisplayString("List item " + o), 1)
                    }), 64))
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}